import { formatMoney } from '@travelity/utils';
import type {
    PackageBookingFormValues,
    PackageBookingItemMeta,
} from '@/views/availability/components/PackageBookingSideform/package-form.helpers';

import { getSelectedOptionPrice } from './getSelectOptionPrice';

export const formatOptionPrice = (
    pricing: PackageBookingItemMeta['optionsCatalog'][number]['pricing'],
    pax: PackageBookingFormValues['pax']
) => {
    const selectedPrice = getSelectedOptionPrice(pricing, pax);

    if (!selectedPrice?.total) return 'Free';

    return selectedPrice.currency
        ? formatMoney(selectedPrice.total, selectedPrice.currency)
        : String(selectedPrice.total);
};
